<template>
    <BCard>
      <ValidationObserver ref="form" #default="{invalid}">
          <BForm @submit.prevent="onSubmit">
              <BRow>
                <TextInputValidated vsName="Name" :vsModel.sync="family.name" vsMd="6" vsRequired vsRules="required" />
              </BRow>

              <!-- Action Buttons -->
              <BButton variant="primary" class="mt-3 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
              <BButton variant="outline-secondary" class="mt-3" type="reset" :to="{ name:'families' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
          </BForm>
      </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BRow, BCol, BForm, BButton, BFormInput, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { onUnmounted, ref } from '@vue/composition-api';
import familyModule from '../familyModule';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import formValidation from '@core/comp-functions/forms/form-validation';
import popups from '@/hooks/popups';
import vSelect from 'vue-select'
import store from '@/store';

export default {
  components: { BCard, BRow, BCol, BForm, BButton, BFormInput, BFormGroup, BFormInvalidFeedback, ValidationProvider, ValidationObserver, extend, vSelect, TextInputValidated },
  setup(){
      const { getValidationState } = formValidation()
      const { errorToast } = popups()
      const FAMILIES_MODULE = 'families'
      const family = ref({ 'name': '' })

      const onSubmit = function(){
          this.$refs.form.validate().then(success => {
              if(success) {
                  store.dispatch('families/addFamily', JSON.parse(JSON.stringify(family.value)))
                      .then(response => { this.$router.push({ name: 'families' }) })
                      .catch(error => { errorToast('Can\'t add family') })
              }
          })
      }

      if(!store.hasModule(FAMILIES_MODULE)) store.registerModule(FAMILIES_MODULE, familyModule)

      onUnmounted(() => {
          if (store.hasModule(FAMILIES_MODULE)) store.unregisterModule(FAMILIES_MODULE)
      })

      return {
          getValidationState,
          onSubmit,
          family
      }
  }
}
</script>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>
